export const _getTutoringAvailabilityDetails = (state, action) => action.payload;

export const _setTutoringAvailabilityDetails = (state, action) => {
    state.timeSlots = action.payload;
  };